import { viewDataByApi } from "./actions"
import { URL_CONSTANTS } from "./urls";

export const getByLinkData = (id) => viewDataByApi(URL_CONSTANTS.get_renewal_customers, id);

